/* eslint-disable max-len */
import React, { memo, useContext } from 'react';

import { useSelector } from 'react-redux';

import { capitalize } from 'lodash';

import ParamsContext from '@components/entity/info/params-context';
import { getEntityTypeLabel } from '@constants/config';

import {
  hasSchedulesWithMissingDates,
  renderWarning,
  showEntityScheduleContainsWarning
} from '@utils/segment-schedule/common';

import '../../../../../forms/forms.scss';

const ScheduleWarning = () => {
  const { dataType } = useContext(ParamsContext);
  const { data } = useSelector(state => state.dataDetail);

  const entityTypeLabel = capitalize(getEntityTypeLabel(dataType));

  // Show warning if schedules exist but activity dates are missing
  if (hasSchedulesWithMissingDates(data.start_date, data.end_date, data.segments)) {
    return (
      <div role="status" styleName="form-warning">
        {renderWarning(`Location schedules exist but ${entityTypeLabel}'s activity dates are missing. Please delete the schedules or populate the activity dates.`)}
      </div>
    );
  }

  // Show warning if schedules are not contained within activity dates
  if (showEntityScheduleContainsWarning(data.start_date, data.end_date, data.segments)) {
    return (
      <div role="status" styleName="form-warning">
        {renderWarning(`Location schedules are not contained within the ${entityTypeLabel}'s activity dates.`)}
      </div>
    );
  }

  return null;
};

export default memo(ScheduleWarning);
